module.exports = __webpack_public_path__ + "img/astro.423d5e8d.webp";